/**
 * Laplace x GTM (branch `gtm`): the public site is reduced to the GTM start
 * page plus /terms and /login. Sign-up opens only from the paid checkout (and
 * invite links, see `isSignupOpen`). The old marketing pages stay in the
 * codebase and are hidden here — remove a key to bring its page back
 * (routes, header/footer links, prerender and sitemap all follow this list).
 *
 * Dependency-free on purpose: the prerender script imports it via Node
 * type-stripping.
 */
export type HideablePublicPage =
  | 'trust'
  | 'demo'
  | 'pricing'
  | 'integrations'
  | 'solutions'
  | 'security'
  | 'resources'
  | 'signup'

const HIDDEN_PUBLIC_PAGES: ReadonlySet<string> = new Set<HideablePublicPage>([
  'signup',
  'trust',
  'demo',
  'pricing',
  'integrations',
  'solutions',
  'security',
])

export function isPublicPageHidden(page: string): boolean {
  return HIDDEN_PUBLIC_PAGES.has(page)
}
